
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "M60.9,2c1.8,13.4,1.5,24.2-1.2,31.1L34.9,14.7C39.8,9.6,49.8,3.5,60.9,2z", fill: "#dadee0" }),
	React.createElement("path", { d: "m57.7 32.2l-10.2-13.3c0 0 1.9-7.3 11.6-12.4 2.9 11.6-1.4 25.7-1.4 25.7", fill: "#f7a4a4" }),
	React.createElement("path", { d: "m53.8 29.2l-6.3-8.2c0 0 2.6-5 8.6-8.2-3.5 7.5-2.3 16.4-2.3 16.4", fill: "#f78d8d" }),
	React.createElement("path", { d: "M3.1,2C1.3,15.4,1.6,26.2,4.3,33.1l24.8-18.5C24.2,9.6,14.2,3.5,3.1,2z", fill: "#dadee0" }),
	React.createElement("path", { d: "m6.3 32.2l10.3-13.3c0 0-1.9-7.3-11.6-12.4-3 11.6 1.3 25.7 1.3 25.7", fill: "#f7a4a4" }),
	React.createElement("path", { d: "m10.2 29.2l6.4-8.2c0 0-2.6-5-8.6-8.2 3.4 7.5 2.2 16.4 2.2 16.4", fill: "#f78d8d" }),
	React.createElement("path", { d: "m58.2 50.8c.8-.9 1.4-1.6 1.7-2.2 1.6-2.6 2.1-5.3 2.1-5.3l-2 .4c0 0 2.3-2.5 1.7-7.8l-2 2.1c0 0 1.9-5.4.3-10.4l-2.2 1.6c0 0 .7-2 .1-3.4l-.9.7c0 0 1.7-4.7.2-6.6-.9 2.8-1.9 2.8-1.9 2.8s1.2-2.1.3-3c-1 1.6-1.8.6-1.8.1.1-.6-.2-1.5 2.7-2-2.3-1.4-5.1-.4-5.1-.4s.1-1.5 2.1-1.4c-1.9-1.6-4.5-.6-4.5-.6-4.1-3.1-9.6-4.9-17.1-4.9-7.4 0-12.9 1.8-17.1 4.9 0 0-2.6-.9-4.5.6 2-.1 2.1 1.4 2.1 1.4s-2.7-1-5.1.4c2.9.4 2.7 1.3 2.7 2 0 .5-.8 1.5-1.8-.1-1 .9.3 3 .3 3s-1 0-1.9-2.8c-1.5 2 .2 6.6.2 6.6l-.9-.7c-.6 1.4.1 3.4.1 3.4l-2-1.6c-1.7 5 .3 10.4.3 10.4l-1.9-2.1c-.7 5.3 1.6 7.8 1.6 7.8l-2-.4c0 0 .5 2.7 2.1 5.3.2.5.8 1.3 1.7 2.2 0 0 0 0 .1.1 4.1 4.1 14.2 11.1 26.1 11.1 11.9 0 22-7 26.1-11.1 0-.1.1-.1.1-.1", fill: "#dadee0" }),
	React.createElement(
		"g",
		{ fill: "#94989b" },
		React.createElement("path", { d: "m37.7 10.8c-1.8-.3-3.7-.4-5.7-.4s-3.9.1-5.7.4c.7 3.9 2.8 6.6 5.7 11.6 3-5.1 5-7.8 5.7-11.6" }),
		React.createElement("path", { d: "m46.8 13.8c-1.9-1.1-4.1-1.9-6.5-2.5.6 2.3 1.9 3.9 3.6 6.9 1.3-2.1 2.2-2.7 2.9-4.4" }),
		React.createElement("path", { d: "m23.7 11.3c-2.5.6-4.6 1.4-6.5 2.5.7 1.8 1.7 2.3 2.9 4.4 1.8-3.1 3-4.7 3.6-6.9" })
	),
	React.createElement("path", { d: "m41.4 53.8c1.6-1.6-1.8-3-1.8-5.9 0-2.9 3.4-4.2 1.8-5.9-1.9-2-6-.5-8.6-3.1 0 2.2 1.8 4.5 5.2 4.5 0 0-2.3.9-2.3 4.5 0 3.6 2.3 4.5 2.3 4.5-3.4 0-5.2 2.3-5.2 4.5 2.5-2.7 6.7-1.2 8.6-3.1", fill: "#4c5359" }),
	React.createElement(
		"g",
		{ fill: "#ff717f" },
		React.createElement("path", { d: "m23 34.7c-1.7-2.8-7-3.8-11.8-2.1-4.8 1.7-7.3 5.4-5.6 8.2 1.7 2.8 7 3.8 11.8 2.1 4.8-1.7 7.3-5.4 5.6-8.2", opacity: ".8" }),
		React.createElement("path", { d: "m41 34.7c1.7-2.8 7-3.8 11.8-2.1 4.8 1.7 7.3 5.4 5.6 8.2-1.7 2.8-7 3.8-11.8 2.1-4.8-1.7-7.3-5.4-5.6-8.2", opacity: ".8" })
	),
	React.createElement(
		"g",
		{ fill: "#4c5359" },
		React.createElement("path", { d: "m35.9 25.6c4.2 8 12.7 8 16.9 0 .2-.4-.3-.6-1-1-4.2 3.3-11.1 3-14.9 0-.6.4-1.2.6-1 1" }),
		React.createElement("path", { d: "m11.2 25.6c4.2 8 12.7 8 16.9 0 .2-.4-.3-.6-1-1-4.2 3.3-11.1 3-14.9 0-.7.4-1.2.6-1 1" })
	)
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/kissing_cat.js
// module id = 709
// module chunks = 0